import store from './store';
import { possibleTabs } from '../reducers/matchmaking';
import { isNetplayPageActive } from 'react/netplay/netplayPageState';
import { NETPLAY_VIEWS, currentView } from 'react/matchmaking/unified/netplayView';

export default class StateHelpers {
	static windowHasVisibility() {
		const { windowIsVisible } = store.getState().windowFocus;
		return windowIsVisible;
	}

	static windowIsFocused() {
		const { windowIsFocused } = store.getState().windowFocus;
		return windowIsFocused;
	}

	static chatIsMinimized() {
		const state = store.getState();
		const { chatLargeMinimized, chatLargeToggledOn } = state.chat;
		const { windowSizeIsMedium, windowSizeIsLarge } = state.windowSize;
		return chatLargeToggledOn && (windowSizeIsMedium || windowSizeIsLarge) && chatLargeMinimized;
	}

	static mainChatIsActive() {
		const state = store.getState();
		const { selectedTab } = state.matchmaking;
		return selectedTab === possibleTabs.chat || StateHelpers.netplayChatViewIsOpen() || StateHelpers.dockChatShowsRoom() || StateHelpers.chatIsPinnedAndActive() || StateHelpers.chatPopupIsActive();
	}

	/** Off the netplay page, the dock's chat sheet shows the selected room (react/dock/chat). */
	static dockChatShowsRoom() {
		const { dockChat } = store.getState();
		return !!(dockChat && dockChat.open && dockChat.conversation && dockChat.conversation.kind === 'room');
	}

	/** The netplay page shows chat in its Chat view, not through selectedTab. */
	static netplayChatViewIsOpen() {
		return isNetplayPageActive() && typeof window !== 'undefined' && currentView() === NETPLAY_VIEWS.chat;
	}

	static chatIsPinnedAndActive() {
		const state = store.getState();
		const { chatLargeMinimized, chatLargeToggledOn } = state.chat;
		const { windowSizeIsMedium, windowSizeIsLarge } = state.windowSize;
		const { showMainChatAsPopup } = state.settings;
		return !showMainChatAsPopup && chatLargeToggledOn && (windowSizeIsMedium || windowSizeIsLarge) && !chatLargeMinimized;
	}

	static chatPopupIsActive() {
		const state = store.getState();
		const { chatLargeMinimized } = state.chat;
		const { windowSizeIsMedium, windowSizeIsLarge } = state.windowSize;
		const { showMainChatAsPopup } = state.settings;
		return showMainChatAsPopup && (windowSizeIsMedium || windowSizeIsLarge) && !chatLargeMinimized;
	}

}

function showMainChatAsPopupHelper() {
	return true;
}